interface SmartLinkIFrameProps {
  url: string;
}

export const SmartLinkIFrame = ({ url }: SmartLinkIFrameProps) => {
  return (
    <div style={{ flex: '1' }}>
      <iframe style={{ zIndex: 0, border: 'none' }} title="smartLink" width="100%" height="100%" src={url} />;
    </div>
  );
};
